import React from 'react';

import MenuView from './Menu-view';

const Menu: React.FC = () => {
  return <MenuView name={'Menu'} />;
};

export default Menu;
